import { useSuspenseQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

interface Timeline {
  listing_id: string
  last_read: string
  room_metadata: string | null
  is_read: string
  is_favourite: string
  last_event: string
  timeline_room: string
  state_machine: string
  units: {
    id: string
    unit_number: string
    hide_unit_number: string
  }
  listings: {
    id: string
    state_machine: string
    listing_tenants: string[]
  }
  applications: {
    id: string
    user_id: string
  }
  buildings: {
    id: string
    building_type_txt_id: string
    name: string
    street_number: string
    street_name: string
    full_street_name: string
    city: string
    state: string
    country_code: string
    zip: string
    neighborhood: string | null
    full_address: string
    geo_address: string
    lat: string
    lng: string
  }
  user_ids: {
    them: string[]
    us: string[]
  }
  primary_user_ids: {
    them: string
    us: string
  }
}

interface Config {
  listingId: string
}

export const useListingTimelines = ({ listingId }: Config) => useSuspenseQuery({
  queryKey: ['listings', listingId, "timelines"],
  queryFn: async () => {
    const data = await client.get(`/timeline/listings/${listingId}`)
    return (data?.timelines ?? {}) as {[key: string]: Timeline}
  },
  refetchInterval: 1000 * 60 * 10
})
